<template>
  <div class="laporan">
    <div>
      <h2>Penyesuaian Stok</h2>

      <div class="form-wrapper">
        <div class="form-group">
          <label>{{
            loadingBahanBaku
              ? "Mengambil data bahan baku..."
              : "Pilih Bahan Baku"
          }}</label>
          <Autocomplete
            v-model="row.nama"
            :nama="row.nama"
            :items="dataBahanBaku"
            :clearOnEnter="true"
            @selected="setRow($event)"
          />
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Barang</th>
              <th>Stok Sistem</th>
              <th>Stok Aktual</th>
              <th>Penyesuaian</th>
              <th>Keterangan</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ ++index }}</td>
              <td>{{ item.nama }}</td>
              <td>{{ item.stok_sistem }} {{ item.satuan }}</td>
              <td>
                <input
                  type="number"
                  v-model="item.jumlah"
                  @input="calculate(item)"
                  style="width: 100px; text-align: center"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model="item.penyesuaian"
                  style="width: 100px; text-align: center"
                  readonly="true"
                />
              </td>
              <td>
                <input type="text" v-model="item.keterangan" />
              </td>
              <td align="right">
                <span @click="hapus(index)">Hapus</span>
              </td>
            </tr>
            <tr v-show="loadingStok">
              <td colspan="7">
                <p style="font-size: 14px; text-align: center">
                  Menghitung stok...
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="action" v-show="data.length > 0">
        <button
          type="button"
          class="btn btn-fill"
          @click="save()"
          :disabled="loadingButton"
        >
          {{ loadingButton ? "Menyimpan..." : "Simpan" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
import Autocomplete from "../../custom/Autocomplete.vue";

export default {
  name: "BahanBakuForm",
  components: {
    Autocomplete,
  },
  data() {
    return {
      loadingBahanBaku: false,
      loadingStok: false,
      loadingButton: false,
      row: {},
      data: [],
      dataBahanBaku: [],
    };
  },
  methods: {
    loadBahanbaku() {
      this.loadingBahanBaku = true;
      api
        .get("/v4/bahan-baku?id_toko=" + this.$toko.id + "&pantau_stok=1")
        .then((r) => {
          this.dataBahanBaku = r.data;
          this.loadingBahanBaku = false;
        })
        .catch((e) => {
          this.$toast(
            "Gagal mengambil data bahan baku, silakan refresh halaman ini"
          );
          this.loadingBahanBaku = false;
        });
    },
    calculate(item) {
      item.penyesuaian = (item.jumlah || 0) - (item.stok_sistem || 0);
    },
    setRow(event) {
      this.loadingStok = true;
      api.get("/v4/stok/sistem?id_barang=" + event.id).then((r) => {
        event.stok_sistem = r.data.stok_sistem;
        this.data.push(event);
        this.loadingStok = false;
      });
    },
    hapus(index) {
      this.data.splice(index - 1, 1);
    },
    save() {
      this.loadingButton = true;
      api.post("/v4/stok/penyesuaian", this.data).then((r) => {
        this.$router.go(-1);
      });
    },
    numFormat(model) {
      this.data[model] = this.$options.filters.number(
        this.data[model].replace(/\./g, "")
      );
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.loadBahanbaku();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .form-wrapper {
    width: 450px;
    margin-top: 30px;
  }

  .action {
    margin-top: 30px;
    button {
      width: 200px;
    }
  }

  .table-wrapper {
    span {
      color: #f00;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/stok/PenyesuaianStokForm.vue